// frontend/src/components/ErrorBoundary.js
import React, { Component } from "react";
import AppHadError from "./AppHadError";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to an error reporting service if needed
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Render custom error UI
      return <AppHadError />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
